import React from "react";
import "./whoweare.css";
import whoWeAreImage from "../images/wardrobes.jpeg";

const points = [
  "Intrading has over 22 years of manufacturing prowess",
  "Reputed maker of world-class, sustainable solid wood furniture since 1996",
  "Supply across five continents North America, South America, Asia, Australia and Europe",
  "We make consciously crafted furniture, created with passion and finesse",
];

function WhoWeAre() {
  return (
    <section className="whoWeAre">
      <div className="whoWeAre__left">
        <h2>WHO WE ARE</h2>

        <div className="whoWeAre__list">
          {points.map((item, index) => (
            <div className="whoWeAre__item" key={index}>
              <span className="bullet"></span>
              <p>{item}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="whoWeAre__right">
        <img src={whoWeAreImage} alt="Hamina Cabinet" />

      

      </div>
    </section>
  );
}

export default WhoWeAre;